import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=04f2a15b&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f2a15b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04f2a15b')) {
      api.createRecord('04f2a15b', component.options)
    } else {
      api.reload('04f2a15b', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=04f2a15b&scoped=true&", function () {
      api.rerender('04f2a15b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iJRYgU2mWcdY/JS/comp/SearchFilterTokens.vue"
export default component.exports